import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { Container, Card, Spinner } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

import Header_Company from "../../Components/Header_Company";
import { BASE_URL } from "../../Config";
import "./Company.css";

const RetailPackages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      setUserId(userData.userId);
    } else {
      Swal.fire("Error", "Your session has expired. Please sign in again.", "error");
    }
  }, []);

  useEffect(() => {
    const fetchPackages = async () => {
      if (!userId) return;

      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}RetailCompanyPackage?id=${userId}`, {
          headers: { accept: "*/*" },
        });

        if (response.data.responseCode === "0000") {
          setPackages(response.data.packages);
        } else {
          Swal.fire("Error", "Failed to fetch packages", "error");
        }
      } catch (error) {
        console.error("Error fetching packages", error);
        Swal.fire("Error", "An error occurred while fetching packages.", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, [userId]);

  const columns = [
    {
      name: "Package Name",
      selector: (row) =>
        `${row.packageName}${row.companyProduct ? ` (${row.companyProduct})` : ""}`,
      sortable: true,
      wrap: true,
    },
    {
      name: "Duration",
      selector: (row) => row.packageDuration,
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => `Rs. ${row.packagePrice}`,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.packageStatus,
      sortable: true,
      cell: (row) => (
        <span
          className={`badge ${
            row.packageStatus === "Active" ? "text-bg-success" : "text-bg-danger"
          }`}
        >
          {row.packageStatus}
        </span>
      ),
    },
  ];

  return (
    <div className="co-page">
      <Header_Company />

      <Container fluid="xl">
        <div className="co-hero">
          <h2>
            <i className="bi bi-box-seam me-2" />
            Retail Packages
          </h2>
          <p>View the package catalog available to your company.</p>
        </div>

        <Card className="co-card">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <i className="bi bi-list-ul me-2 text-primary" />
              Packages
            </h5>
            <span className="badge text-bg-light border">{packages.length} total</span>
          </Card.Header>
          <Card.Body>
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="text-muted mt-2 mb-0">Loading packages...</p>
              </div>
            ) : (
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={packages}
                  pagination
                  highlightOnHover
                  responsive
                  striped
                  noDataComponent={
                    <div className="py-4 text-muted">
                      <i className="bi bi-inbox fs-3 d-block mb-2" />
                      No packages available
                    </div>
                  }
                />
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default RetailPackages;
